/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Application_Status_AllInputs */

const en_admin_user_list_application_status_all = /** @type {(inputs: Admin_User_List_Application_Status_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All applications`)
};

const de_admin_user_list_application_status_all = /** @type {(inputs: Admin_User_List_Application_Status_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Bewerbungen`)
};

/**
* | output |
* | --- |
* | "All applications" |
*
* @param {Admin_User_List_Application_Status_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_application_status_all = /** @type {((inputs?: Admin_User_List_Application_Status_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Application_Status_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_application_status_all(inputs)
	return en_admin_user_list_application_status_all(inputs)
});